"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error, {
      tags: { area: "global-error-boundary" },
      extra: { digest: error.digest },
    });
  }, [error]);

  return (
    <html>
      <body>
        <main style={{ padding: "2rem", fontFamily: "sans-serif" }}>
          <h2>Something went wrong</h2>
          <p>We captured this error and are looking into it.</p>
          <button onClick={() => reset()} style={{ marginTop: "1rem" }}>
            Try again
          </button>
        </main>
      </body>
    </html>
  );
}
